import { InsertAnchor } from './insert-anchor.js';
import { LinkToAnchor } from './link-to-anchor.js';
import { AnchorToc } from './anchor-toc.js';


export function Anchor (pEditor)
{
  this.inserter = new InsertAnchor(pEditor, this);
  this.link = new LinkToAnchor(pEditor, this);
  this.toc = new AnchorToc(pEditor, this);
  
  let allAnchors = [],
      currentAnchorIndex = null;


  this.collectAnchors = (content, isSelectively) =>
  {
    if (!content.match(/<a\s[^>]*name\s*=['"]?[^'"\s>]['"]?/i))
    {
      return content;
    }

    var i;
    var fragment, elements;
    var anchorIndex;
    var copyElements = [];

    var anchorVisualTag = document.createElement('IMG');
    anchorVisualTag.src = '/Admin/html_res/images/editor-in-anchor.gif?' + BEditor.environment.version;
    anchorVisualTag.border = '0';
    anchorVisualTag.className = 'anchorInEditor';
    anchorVisualTag.style.border = '0';
    anchorVisualTag.style.border = 'none';
    anchorVisualTag.style.background = 'none';
    anchorVisualTag.style.padding = '0';
    anchorVisualTag.style.margin = '0';
    anchorVisualTag.style.verticalAlign = 'middle';
    var cloneAnchorVisualTag;

    if (!isSelectively)
    {
      allAnchors = [];
    }

    anchorIndex = allAnchors.length;

    fragment = pEditor.iFrameDoc.createElement('DIV');
    fragment.innerHTML = (BEditor.browser.isIE) ? '.<!--###S*D*A*S*M*A*S*G*D=F3773A+CCAFDA###-->' + content : content;
    elements = fragment.getElementsByTagName('A');

    for (i = 0; i < elements.length; i++)
    {
      if (elements[i].getAttribute('name') && !elements[i].getAttribute('href'))
      {
        copyElements.push(elements[i]);
      }
    }

    for (i = 0; i < copyElements.length; i++)
    {
      allAnchors[anchorIndex] = {};
      allAnchors[anchorIndex].name = copyElements[i].getAttribute('name');
      allAnchors[anchorIndex].content = copyElements[i].innerHTML.trim();

      cloneAnchorVisualTag = anchorVisualTag.cloneNode(false);
      cloneAnchorVisualTag.setAttribute('data-anchorIndex', 'UserCustomAnchor-' + anchorIndex, 0);
      cloneAnchorVisualTag.setAttribute('title', allAnchors[anchorIndex].name, 0);
      cloneAnchorVisualTag.setAttribute('alt', allAnchors[anchorIndex].name, 0);

      copyElements[i].parentNode.replaceChild(cloneAnchorVisualTag, copyElements[i]);
      anchorIndex++;
    }

    content = fragment.innerHTML;
    content = (BEditor.browser.isIE) ? content.replace(/\.<!--\s*###S\*D\*A\*S\*M\*A\*S\*G\*D=F3773A\+CCAFDA###\s*-->/ig, '') : content;
    content = content.replace(/(<img\s[^>]*data-anchorIndex=['"]?UserCustomAnchor-(\d+)['"]?[^>]*>)/ig, function(str, img, num)
    {
      num = parseInt(num);
      return (!isNaN(num) && allAnchors[num]) ? img + allAnchors[num].content : img;
    });

    return content;
  };


  this.reCollectAnchors = () =>
  {
    var i;
    var anchorIndex, anchorName;
    var imgs = pEditor.iFrameDoc.body.getElementsByTagName('IMG');

    for (i = 0; i < imgs.length; i++)
    {
      if (imgs[i].getAttribute('data-anchorIndex') && imgs[i].getAttribute('alt'))
      {
        anchorIndex = parseInt((imgs[i].getAttribute('data-anchorIndex')).replace(/UserCustomAnchor-(\d+)/i, '$1'));

        if (!isNaN(anchorIndex))
        {
          anchorName = imgs[i].getAttribute('alt');

          if (!allAnchors[anchorIndex] || !allAnchors[anchorIndex].name || allAnchors[anchorIndex].name != anchorName)
          {
            anchorIndex = allAnchors.length;
            allAnchors[anchorIndex] = {};
            allAnchors[anchorIndex].name = anchorName;
            allAnchors[anchorIndex].content = '';
            imgs[i].setAttribute('data-anchorIndex', 'UserCustomAnchor-' + anchorIndex, 0);
          }
        }
      }
    }
  };


  this.restoreAnchors = (content) =>
  {
    content = content.replace(/<img\s[^>]*data-anchorIndex=['"]?UserCustomAnchor-(\d+)['"]?[^>]*>/ig, function(str, num)
    {
      num = parseInt(num);
      return (!isNaN(num) && allAnchors[num]) ? '<a name="' + allAnchors[num].name + '"></a>' : '';
    });

    return content;
  };


  const getAnchorIndex = () =>
  {
    var currentSelection = pEditor.range.selection.getCurrent();
    var currentRange = pEditor.range.getCurrent();
    var currentElement;
    var anchorIndex;
    var ret = null;

    if (BEditor.browser.isIE)
    {
      if (currentSelection.type.toUpperCase() == 'CONTROL' && currentRange.length == 1 &&
          currentRange.item(0).nodeName.toUpperCase() == 'IMG' && currentRange.item(0).getAttribute('data-anchorIndex') &&
          currentRange.item(0).getAttribute('data-anchorIndex').toLowerCase().indexOf('usercustomanchor-') != -1)
      {
        anchorIndex = parseInt(currentRange.item(0).getAttribute('data-anchorIndex').match(/\d+/));
        ret = (!isNaN(anchorIndex) && allAnchors[anchorIndex]) ? anchorIndex : null;
      }

      if (ret == null && pEditor.isEditorInHeader && currentAnchorIndex != null)
      {
        ret = currentAnchorIndex;
      }
    }
    else
    {
      if (currentRange.startContainer == currentRange.endContainer && currentRange.endOffset - currentRange.startOffset < 2 && currentRange.startContainer.hasChildNodes())
      {
        currentElement = currentRange.startContainer.childNodes[currentRange.startOffset];

        if (currentElement &&
          currentElement.nodeName.toUpperCase() == 'IMG' &&
          currentElement.getAttribute('data-anchorIndex') &&
          currentElement.getAttribute('data-anchorIndex').toLowerCase().indexOf('usercustomanchor-') != -1)
        {
          anchorIndex = parseInt(currentElement.getAttribute('data-anchorIndex').match(/\d+/));
          ret = (!isNaN(anchorIndex) && allAnchors[anchorIndex]) ? anchorIndex : null;
        }
      }
    }

    return ret;
  };


  this.selectAnchorVisualTag = (element) =>
  {
    var objRange;
    var objSelection = pEditor.iFrame.getSelection();

    if (objSelection)
    {
      objSelection.removeAllRanges();
      objSelection.selectAllChildren(element);
      objSelection.removeAllRanges();
      objRange = pEditor.iFrameDoc.createRange();
      objRange.selectNode(element);
      objSelection.addRange(objRange);
    }
  };


  this.isAnchorSelected = () =>
  {
    return (getAnchorIndex() != null);
  };


  this.getAnchorsList = () =>
  {
    return (pEditor.pThis.getMultiAnchorsList) ? pEditor.pThis.getMultiAnchorsList() : getAnchorsListDo();
  };


  const getAnchorsListDo = () =>
  {
    var i;
    var matchName, num;
    var anchorsList = [];
    var tags = pEditor.iFrameDoc.body.getElementsByTagName('IMG');

    for (i = 0; i < tags.length; i++)
    {
      if (tags[i].getAttribute('data-anchorIndex', 0))
      {
        matchName = tags[i].getAttribute('data-anchorIndex', 0).match(/UserCustomAnchor-(\d+)/i);

        if (matchName && matchName.length > 1)
        {
          num = parseInt(matchName[1]);

          if (!isNaN(num) && allAnchors[num])
          {
            anchorsList.push({ anchorIndex: num, anchorName: allAnchors[num].name });
          }
        }
      }
    }

    return anchorsList;
  };
  
  
  function queryStateAnchors (pButton, command)
  {
    return (pEditor.iFrameDoc.body.className && pEditor.iFrameDoc.body.className.indexOf('controlVisibilityAnchorInEditor') != -1) ? false : true;
  }


  this.setAnchorsVisibility = (pButton) =>
  {
    var state = queryStateAnchors(pButton);
    return (pEditor.pThis.setMultiAnchorsVisibility) ? pEditor.pThis.setMultiAnchorsVisibility(state) : setAnchorsVisibilityDo(state);
  };


  function setAnchorsVisibilityDo (state)
  {
    var nextYear = new Date();
    nextYear.setFullYear(nextYear.getFullYear() + 1);

    if (state)
    {
      pEditor.iFrameDoc.body.className = ((pEditor.iFrameDoc.body.className) ? pEditor.iFrameDoc.body.className + ' ' : '') + 'controlVisibilityAnchorInEditor';
      document.cookie = 'ShowAnchorsInEditor=0;expires=' + nextYear.toGMTString() + ';path=/';
    }
    else
    {
      pEditor.iFrameDoc.body.className = pEditor.iFrameDoc.body.className.replace(/(.*?)\s?controlVisibilityAnchorInEditor(.*?)/, '$1$2');
      document.cookie = 'ShowAnchorsInEditor=1;expires=' + nextYear.toGMTString() + ';path=/';
    }
  }


  this.fixLinksToAnchors = (htmlContent) =>
  {
    if (BEditor.browser.isIE)
    {
      var cleanedLocationHref = pEditor.helpers.winLocationHref.replace(/&amp;/ig, '&').replace(/#.*?$/, '');
      var cleanedIFrameHref = pEditor.iFrame.location.href.replace(/&amp;/ig, '&').replace(/#.*?$/, '');

      htmlContent = htmlContent.replace(/(<a[\s\r\n].*?href\s*=\s*['"])(.*?)(#.+?)(['"])(.*?>)/ig, function(bigStr, beginStr, hrefStr, anchorStr, endStr1, endStr2)
      {
        hrefStr = hrefStr.replace(/&amp;/ig, '&');

        if (hrefStr.trim() == '' || hrefStr.toLowerCase() == cleanedLocationHref.toLowerCase() || hrefStr.toLowerCase() == cleanedIFrameHref.toLowerCase())
        {
          endStr1 += ' data-anchorhref="' + anchorStr + '"';
          hrefStr = cleanedLocationHref;
        }

        return beginStr + hrefStr + anchorStr + endStr1 + endStr2;
      });
    }

    return htmlContent;
  };


  this.restoreLinksToAnchors = (htmlContent) =>
  {
    if (htmlContent == null)
    {
      htmlContent = pEditor.iFrameDoc.body;
    }

    if (typeof(htmlContent) != 'string')
    {
      if (BEditor.browser.isIE)
      {
        var i;
        var anchorHref;
        var elements = htmlContent.getElementsByTagName('A');

        for (i = 0; i < elements.length; i++)
        {
          anchorHref = elements[i].getAttribute('data-anchorhref', 0);

          if (anchorHref)
          {
            elements[i].href = anchorHref;
          }
        }
      }
    }
    else
    {
      if (BEditor.browser.isIE)
      {
        htmlContent = htmlContent.replace(/<a\s[^>]*data-anchorhref[^>]+>/ig, function (str)
        {
          var matchAnchor = str.match(/\sdata-anchorhref\s*=\s*['"]([^>]*?)['"]/i);

          if (matchAnchor && matchAnchor.length === 2 && matchAnchor[1].indexOf('#') !== -1)
          {
            return str.replace(/\shref\s*=\s*['"][^>]*?#[^>]+?['"]/i, ' href="' + matchAnchor[1] + '"');
          }
          else
          {
            return str;
          }
        });
      }

      return htmlContent;
    }
  };


  this.getAnchorIndex = getAnchorIndex;
  this.getAnchorsListDo = getAnchorsListDo;
  this.queryStateAnchors = queryStateAnchors;
  this.setAnchorsVisibilityDo = setAnchorsVisibilityDo;

  Object.defineProperty(this, 'allAnchors', { get: () => allAnchors });
  Object.defineProperty(this, 'currentAnchorIndex', { get: () => currentAnchorIndex, set: v => { currentAnchorIndex = v }});
}